import { render, staticRenderFns } from "./Lgx02844618467969308033940.vue?vue&type=template&id=3241bee4&scoped=true&"
import script from "./Lgx02844618467969308033940.vue?vue&type=script&lang=js&"
export * from "./Lgx02844618467969308033940.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02844618467969308033940.vue?vue&type=style&index=0&id=3241bee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241bee4",
  null
  
)

export default component.exports